/** Fraud detection configuration thresholds */
export const FRAUD_CONFIG = {
  /** Minimum scroll speed (px/ms) considered suspicious */
  rapidScrollSpeed: 12,
  /** Max direction changes within window before flagging */
  directionChangeLimit: 6,
  /** Time window (ms) for counting direction changes */
  directionChangeWindowMs: 2000,
  /** Cooldown (ms) between repeated direction-change warnings */
  cooldownMs: 3000,
  /** Throttle interval (ms) for scroll event listener */
  scrollThrottleMs: 100,
  /** Minimum scroll distance (px) to count as direction change — mobile */
  minDirectionChangeDistanceMobile: 80,
  /** Minimum scroll distance (px) to count as direction change — desktop */
  minDirectionChangeDistanceDesktop: 280,
  /** Viewport width (px) below which mobile thresholds apply */
  mobileBreakpoint: 768,
  /** Duration (ms) for fraud warning toast */
  warningToastDurationMs: 5000,
  /** Delay (ms) before resuming timer after slow scroll detected */
  slowScrollResumeDelayMs: 2000,
} as const;

/** localStorage / sessionStorage key constants */
export const INTERACTION_STORAGE_KEYS = {
  timer: 'ss_interaction_timer',
  onboarding: 'ss_interaction_onboarding',
  onboardingAutoShown: 'ss_interaction_onboarding_auto_shown',
  scrollTooltipShown: 'ss_interaction_scroll_tooltip_shown',
  fraudCount: 'ss_interaction_fraud_count',
} as const;

/** Total duration for the interaction timer (seconds) */
export const TIMER_DURATION_SECONDS = 60;

/** Interval (ms) for persisting timer state to localStorage */
export const TIMER_PERSIST_INTERVAL_MS = 5000;

/** Delay (ms) before countdown display transitions after timer start/stop */
export const STATE_TRANSITION_DELAY_MS = 600;

/** Auto-dismiss delay (ms) for reward toast */
export const REWARD_AUTO_DISMISS_MS = 5000;
